<template>
    <div class="container-fluid">
        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm">

            <GardenHelpCreateQuoteForm v-if="!show_quote_details" :job_id="job_id"
                :perosnal_data_type="perosnal_data_type" :first_name="first_name" :last_name="last_name" :email="email"
                :phone_number="phone_number" :contact_through="contact_through" :services_list="services_list"
                :job_services="job_services" :quote_services="quote_services" :quote_items="quote_items"
                :products_list="products_list" :show_products="show_products" :currency="currency_code" />

            <GardenHelpQuoteDetails v-else class="mt-3" :quote_table_items="quote_table_items"
                :contractor_name="contractor_name" :issue_date="issue_date" :booking_date="booking_date"
                :job_type="job_type" :quote_number="quote_number" :customer_name="customer_name"
                :quote_status="quote_status" :subtotal="subtotal" :vat="vat" :vat_number="vat_no" :total="total"
                :currency_code="currency_code" :currency_icon="currency_icon" :company_logo="company_logo"
                :company_reg_no="company_reg_no" />


            <b-row class="justify-content-center justify-content-lg-right mt-3 mx-0" v-if="!show_quote_details">
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button type="button" variant="garden-help-info-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickCancelCreateQuote">Back</b-button>
                </b-col>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button type="button" variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickReviewQuoteDetails">Review Quote
                        Details</b-button>
                </b-col>
            </b-row>

            <b-row class="justify-content-center justify-content-lg-right mt-3 mx-0 " v-else>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button type="button" variant="garden-help-info-outline"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickCancelQuote">Back</b-button>
                </b-col>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button v-if="!is_loading_save_only" type="button"  variant="garden-help-secondary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickSaveQuote(1)">Save Quote
                        Only</b-button>
                    <b-button v-else-if="is_loading_save_only" type="button" disabled variant="garden-help-secondary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100">
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
                <b-col xl="3" lg="4" md="6" class=" text-center">
                    <b-button v-if="!is_loading_save_send" type="button"  variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100" @click="clickSaveQuote(0)">Save and Send
                        Quote</b-button>
                    <b-button v-else-if="is_loading_save_send" type="button" disabled variant="garden-help-primary"
                        class="btn-bumblebee btn-garden-help mb-1 w-100">
                        <b-spinner small label="Small Spinner" variant="light"></b-spinner>
                        Loading
                    </b-button>
                </b-col>
            </b-row>

        </b-overlay>

    </div>
</template>


<script>
import axios from "axios";
import $ from "jquery";
import GardenHelpCreateQuoteForm from "./CreateQuoteForm.vue";
import GardenHelpQuoteDetails from "./QuoteDetails.vue"

import { listServicesRequest } from "@/utils/helper-functions-garden-help.js"
import countries_list from '@/assets/country-list-data.json'

export default {
    name: "GardenHelpCreateQuoteIndex",
    components: { GardenHelpCreateQuoteForm, GardenHelpQuoteDetails, },
    data() {
        return {
            client_name: "GARDENHELP",
            user_type: null,
            user_id: null,
            user: null,

            show_overlay: false,

            show_quote_details: false,
            /////////

            job_id: null,
            job_obj: null,
            //customer data
            perosnal_data_type: "view",
            first_name: "",
            last_name: "",
            email: "",
            phone_number: "",
            contact_through: null,
            // services
            services_list: [],
            job_services: [],
            quote_services: [{
                service_id: null,
                service_name: null,
                invalid_service: false,
                estimated_price: null,
                invalid_estimated_price: false,
                description: null,
            }],
            // items/products
            quote_items: [{
                name: null,
                invalid_name: false,
                description: null,
                quantity: 1,
                invalid_quantity: false,
                price: null,
                invalid_price: false
            }],
            products_list: [
                { id: 1, name: "product 1" },
                { id: 2, name: "product 2" },
                { id: 3, name: "product 3" },
            ],
            show_products: false,

            // view quote details
            quote_table_items: [],
            contractor_name: null,
            issue_date: null, //new Date(),
            booking_date: null,
            job_type: null,
            quote_number: null,
            customer_name: null,
            quote_status: null,

            subtotal: null,
            vat: null,
            total: null,
            vat_no: null,

            quote_id: null,
            send_customer_email: false,

            country: null,
            currency_code: null,
            currency_icon: null,

            company_logo: null,
            company_reg_no: null,

            is_loading_save_send: false,
            is_loading_save_only: false

        }
    },
    async mounted() {
        this.job_id = Number(this.$route.params.id);
        this.user_type = localStorage.getItem('user_type')
        this.user = JSON.parse(window.localStorage.getItem("user"));
        this.user_id = this.user.id

        this.send_customer_email = this.$route.params.send_email
        console.log('send customer', this.send_customer_email)

        this.show_overlay = true

        this.services_list = await this.listServicesRequest(this.user)
        console.log(this.services_list)

        this.getJobDetails()
        this.getContractorData()

        this.country = this.user.country
        const country_data = countries_list.find(({ country }) => country === this.user.country);
        console.log(country_data)
        this.currency_code = country_data.currency_code
        this.currency_icon = country_data.currency_icon


    },
    methods: {
        listServicesRequest,
        getJobDetails() {
            axios
                .get("/jobs/jobs/" + this.job_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)

                    this.job_obj = response.data
                    setTimeout(() => {
                        this.quote_services = []
                        // set personal data
                        this.first_name = this.job_obj.contact.first_name
                        this.last_name = this.job_obj.contact.last_name
                        this.phone_number = this.job_obj.contact.phone
                        this.email = this.job_obj.contact.email
                        this.contact_through = this.job_obj.contact.contact_through

                        // set services data
                        this.job_services = this.job_obj.orig_services

                        for (let i = 0; i < this.job_services.length; i++) {
                            let service = this.job_services[i]
                            this.quote_services.push({
                                service_id: service.id,
                                service_name: service.name,
                                invalid_service: false,
                                estimated_price: null,
                                invalid_estimated_price: false,
                                description: null,
                                is_orign_service: true
                            })
                        }

                        /////// set quote details data
                        this.issue_date = this.job_obj.created_at
                        this.booking_date = this.job_obj.details.booking_date_web
                        this.job_type = this.job_obj.property.type
                        this.quote_number = ''
                        this.customer_name = this.job_obj.contact.name
                        this.quote_status = 'open'

                        this.contractor_name = this.user.name

                        this.quote_id = Number(this.$route.params.quote_id) // for request job
                        if (this.$route.params.quote_id != null) {
                            this.getQuoteData()
                        } else {

                            this.show_overlay = false
                        }


                    }, 1500)

                });
        },
        getContractorData() {
            console.log("in get contractor data", this.user_type, this.user_id)
            this.show_overlay = true

            axios
                .get("/operator/contractor/profile", {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    this.vat_no = response.data.vat_no
                    this.company_reg_no = response.data.company_reg_no
                    this.company_logo = response.data.logo


                });
        },

        getQuoteData() {
            axios
                .get("/payment/invoices/" + this.quote_id, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)

                    this.quote_status = response.data.status
                    this.quote_number = response.data.invoice_number
                    this.issue_date = response.data.created_at

                    this.show_overlay = false
                });
        },

        clickCancelCreateQuote() {
            this.$router.push({ name: "GardenHelpJobsDetails", params: { id: this.job_id } });

        },

        clickReviewQuoteDetails() {
            console.log("in click review quote details")

            let is_valid_services = this.checkQuoteServicesValidation(),
                is_valid_items = this.checkQuoteItemsValidation()

            if (is_valid_services && is_valid_items) {

                this.subtotal = 0
                this.quote_table_items = []

                for (let i = 0; i < this.quote_services.length; i++) {
                    // let selected_service = this.services_list.find(element => element.id == this.quote_services[i].service_id)
                    // console.log(i, selected_service)
                    console.log(this.quote_services[i])
                    // this.quote_services[i].service_name = selected_service.name

                    let item = this.quote_services[i]
                    this.quote_table_items.push({
                        type: "service",
                        item_id: this.quote_services[i].is_orign_service ? this.quote_services[i].service_id : this.quote_services[i].service_id.id,
                        name: this.quote_services[i].is_orign_service ? this.quote_services[i].service_name : this.quote_services[i].service_id.name,
                        price_str: this.currency_icon + item.estimated_price,
                        price: item.estimated_price,
                        description: item.description
                    })

                    this.subtotal += Number(item.estimated_price)
                }

                if (this.quote_items.length >= 1 && this.quote_items[0].name != null && this.quote_items[0].name != '') {
                    for (let j = 0; j < this.quote_items.length; j++) {

                        let item = this.quote_items[j],
                            items_price = item.quantity * item.price

                        this.quote_table_items.push({
                            type: "item",
                            item_id: null,
                            name: item.name,
                            quantity: item.quantity,
                            price_str: this.currency_icon + items_price,
                            price: items_price,
                            price_per_item: item.price,
                            description: item.description
                        })

                        this.subtotal += Number(items_price)
                    }
                }


                this.vat = this.vat_no != null ? (this.subtotal * 0.135).toFixed(3) : 0 // Update the vat from 23% to 13.5% upon Ed request 12/8/2024
                this.total = (Number(this.subtotal) + Number(this.vat)).toFixed(3)

                console.log(this.quote_table_items)

                this.show_quote_details = !this.show_quote_details
            }
        },
        checkQuoteServicesValidation() {
            let is_valid_services = true
            for (let i = 0; i < this.quote_services.length; i++) {
                let quote_service = this.quote_services[i]
                if (quote_service.service_id == null || quote_service.service_id == '') {
                    this.quote_services[i].invalid_service = true
                    is_valid_services = false
                } else {
                    this.quote_services[i].invalid_service = false
                }

                if (quote_service.estimated_price == null || quote_service.estimated_price == '') {
                    this.quote_services[i].invalid_estimated_price = true
                    is_valid_services = false
                } else {
                    this.quote_services[i].invalid_estimated_price = false
                }
            }
            return is_valid_services;
        },
        checkQuoteItemsValidation() {
            console.log("check item validation")
            let is_valid_items = true
            for (let i = 0; i < this.quote_items.length; i++) {
                let quote_item = this.quote_items[i]
                console.log(quote_item)
                console.log(quote_item.price, quote_item.price == null, quote_item.price == '')
                console.log(quote_item.name, quote_item.name == null, quote_item.name == '')

                if ((quote_item.name != null && quote_item.name != '') ||
                    (quote_item.price != null && quote_item.price != '') ||
                    (quote_item.quantity != null && quote_item.quantity != '' && quote_item.quantity != 1) ||
                    (quote_item.description != null && quote_item.description != '')) {

                    if (quote_item.name == null || quote_item.name == '') {
                        this.quote_items[i].invalid_name = true
                        is_valid_items = false
                    } else {
                        this.quote_items[i].invalid_name = false
                    }

                    if (quote_item.quantity == null || quote_item.quantity == '') {
                        this.quote_items[i].invalid_quantity = true
                        is_valid_items = false
                    } else {
                        this.quote_items[i].invalid_quantity = false
                    }

                    if (quote_item.price == null || quote_item.price == '') {
                        this.quote_items[i].invalid_price = true
                        is_valid_items = false
                    } else {
                        this.quote_items[i].invalid_price = false
                    }
                }
                if (quote_item.quantity === 1) {
                    this.invalid_quantity = false
                }
            }
            return is_valid_items;
        },

        clickCancelQuote() {
            this.show_quote_details = !this.show_quote_details

        },
        clickSaveQuote(save_only) {
            console.log("click save and send quote")
            console.log("job id", this.job_id)
            console.log("subtotal", this.subtotal)
            console.log("vat", this.vat)
            console.log("total", this.total)
            console.log(this.quote_table_items)
            console.log(this.quote_id, this.quote_id == null, isNaN(this.quote_id))

            if (save_only == 1) {
                this.is_loading_save_only = true
            } else {
                this.is_loading_save_send = true
            }

            let requestData = {
                client: this.client_name,
                "status": "quote",
                "subtotal": this.subtotal,
                "vat": Number(this.vat),
                "total": this.total,
                "currency": this.currency_code,
                "model_type": "Job",
                "model_id": this.job_id,
                "client": "GARDENHELP",
                "invoice_items": this.quote_table_items,
                "save_only": save_only
            }

            let params = ''
            if (isNaN(this.quote_id)) {
                console.log("send quote")
                params = ''

                // if (this.send_customer_email == 't') {
                //     requestData.send_email = 1
                // }
            } else {
                console.log("request quote", this.quote_id)
                params = '/' + this.quote_id
                requestData.id = this.quote_id
                requestData._method = 'put'
            }


            console.log(requestData)
            console.log(params)

            axios
                .post("payment/invoices" + params, requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response);
                    this.$fire({
                        // title: "Title",
                        text: "Quote is created successfully ",
                        type: "success",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.is_loading_save_only = false;
                        this.is_loading_save_send = false;
                        // this.$router.go();
                        this.$router.push({ name: "GardenHelpMyJobs", query: { type: 'quotes' } });
                    });
                })
                .catch((error) => {
                    console.log(error.response);
                    this.is_loading = false;
                    this.$fire({
                        // title: "Title",
                        text: error.response.data.error
                            ? error.response.data.error
                            : error.response.data.message,
                        type: "error",
                        customClass: {
                            container: "swal-alert-garden-help",
                            confirmButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-primary btn-garden-help-submit",
                            cancelButton:
                                "btn btn-bumblebee btn-garden-help btn-garden-help-danger-outline btn-garden-help-submit",
                        },
                        // timer: 3000,
                    }).then((r) => {
                        // console.log(r.value);
                        this.is_loading_save_only = false;
                        this.is_loading_save_send = false;
                    });
                });

        },
    }
}

</script>


// WEBPACK FOOTER //
// src/projects/garden_help/quotes/CreateQuoteIndex.vue